import BaseForm from '../base';
export class ShutoffThresholdPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
